<template>
  <Intro />
  <OurValues />
  <OurTeam />
  <OurServices />
  <OurFacilities />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/aboutus/AboutUsIntro.vue";
import OurTeam from "@/components/aboutus/OurTeam.vue";
import OurValues from "@/components/aboutus/OurValues.vue";
import OurServices from "@/components/aboutus/OurServices.vue";
import OurFacilities from "@/components/aboutus/OurFacilities.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

